var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 140",
    enableBackground: "new 0 0 512 140",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AI_00000080174295890536950830000011703789782273157028_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 70,
    x2: 512,
    y2: 70
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0E56E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00653846,
    style: {
      stopColor: "#0E56E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#12C4E1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "AI",
    fill: "url(#AI_00000080174295890536950830000011703789782273157028_)",
    d: "M512,0c-30.5,54.5-60.5,42.5-83.2,60.5 c-32,25.5-96.3,49.8-160.3,32.7c-26.1-7-48.1-3.3-69.7,0.4c-30.9,5.2-61,10.5-101.3-15.2C55.6,51.8,30.9,49.4,0,67v73h512V0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAi);
export default __webpack_public_path__ + "static/media/Nav-AI.f20b111e.svg";
export { ForwardRef as ReactComponent };